import { TOKEN_STORAGE_KEY } from './../app.constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

import { LocalStorageService } from 'ngx-webstorage';
import { ServerUrl } from '../services/server-url.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly serverUrl: ServerUrl
  ) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const serverApi = this.serverUrl.get();
    if (!request || !request.url || (/^http/.test(request.url) && !(serverApi && request.url.startsWith(serverApi)))) {
      return next.handle(request);
    }

    const token = this.localStorageService.retrieve(TOKEN_STORAGE_KEY);
    if (token) {
      // tslint:disable-next-line:no-parameter-reassignment
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + token,
        },
      });
    }
    return next.handle(request);
  }
}
